import React from "react";
import homeImage from "../assets/earth1.gif";

const  Hero=()=> {

  return (
<>
<div style={{background: '#89CFF0'}} className="mx-4 py-5 rounded">


      <div className="background text-center">
        <img src={homeImage} alt="" />
      </div>
      <div className="content text-center">
        <div className="title">
          <h1>EXPLORE THE STORES/SHOPS/SERVICE PROVIDERS</h1>
          <p>
            Become friends with Daz to be the first one to know about exclusive deals and discounts!
          </p>
        </div>
        <div className="search">
          <div className="container">
            <label htmlFor="">Which product are you looking for?</label> 
            <input type="text" placeholder="Search Your product" />
          </div>
          <button style={{cursor:' pointer',  border:' 0', outline: '0', color: '#48cae4'}}>Search</button>
        </div>
      </div>
      </div>
      </>
  );
}
export default Hero;

